import { PagePlaceholder } from "../components/PagePlaceholder";

export function PlacementsPage() {
	return (
		<PagePlaceholder
			title="Placements"
			subtitle="Where, when, and what variants of your products are being considered."
			endpoint="/v1/insights/manufacturer/placements"
			rails={[
				{ heading: "Placements over time", body: "Line chart with optional comparison line." },
				{ heading: "Top 5 products", body: "Sorted by placements in the period." },
				{ heading: "Top 5 metros", body: "MSA / NUTS-2 / country fallback." },
				{ heading: "Top 5 project types", body: "Commercial / hospitality / retail / etc." },
			]}
		/>
	);
}
